/**
 * src/components/business-page/BusinessPage.js
 *
 * Página de detalle de un negocio. Lee el :id de los params del router,
 * carga los datos y orquesta Sidebar + Gallery + CTA.
 */

import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'
import { getById } from '@/db/businesses.db.js'
import { trackClick } from '@/shared/utils/track.js'

define('BusinessPage', ({ params = {} }) => {
    const business = getById(params.id)

    if (business) trackClick('business', business.id)

    if (!business) {
        return h('div', { className: 'page page--business' },
            c('Header'),
            h('div', { className: 'biz-page__not-found' },
                h('h2', {}, '404 — Negocio no encontrado'),
                h('a', { href: '/directorio', className: 'biz-cta__btn' }, '← Volver al directorio')
            )
        )
    }

    if (business.plan === 'oro') {
        return h('div', { className: 'page page--business' },
            c('Header'),
            c('GoldPage', { business })
        )
    }

    return h('div', { className: 'page page--business' },
        c('Header'),
        h('div', { className: 'biz-page' },
            h('div', { className: 'biz-page__inner' },
                c('BusinessSidebar', { business }),
                h('div', { className: 'biz-page__main' },
                    c('BusinessGallery', {
                        image:   business.image,
                        gallery: business.gallery,
                        name:    business.name
                    }),
                    c('BusinessCTA', {
                        whatsapp: business.whatsapp,
                        name:     business.name
                    }),
                    c('BusinessReviews', { businessId: business.id })
                )
            )
        )
    )
})
